
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 13 14","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Page-1"}},[_c('g',{attrs:{"id":"Configuration-V3.1.1","transform":"translate(-981 -302)"}},[_c('g',{attrs:{"id":"icons_x2F_28_x2F_notif_x2F_on","transform":"translate(973 295)"}},[_c('g',{attrs:{"id":"bell_icn","transform":"translate(8 7)"}},[_c('path',{staticClass:"st0",attrs:{"id":"Path","d":"M4.8 12.1c-.2 0-.3.2-.3.4.3.7 1.1 1.2 1.9 1.2s1.6-.5 1.9-1.2c.1-.2 0-.4-.3-.4H4.8z"}}),_c('path',{staticClass:"st0",attrs:{"id":"Shape","d":"M6.5 11.6H1.7c-.5 0-1-.3-1.2-.8-.2-.5-.1-1 .3-1.3 1.5-1.5 1.5-2.6 1.5-4 0-.6 0-1.3.1-2.1C2.7 1.6 4.2.3 6 .3h.7c1.8 0 3.3 1.3 3.6 3.1.1.8.1 1.5.1 2.1 0 1.5 0 2.5 1.5 4 .4.4.5.9.3 1.3-.2.5-.6.8-1.2.8H6.5z"}})])])])])])
          )
        }
      }
    